import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import FollowLink from 'components/common/Link/FollowLink'
import Link from 'components/common/Link/Link'
import Badge from 'components/common/Badge/Badge'
import Image from 'components/common/Image'
import { H2 } from 'components/common/Text/Text'
import { processBrandPageLink } from 'helpers/brand-details'
import { dynamicDataAttribute, toOneString } from 'helpers/utils'

const Records = ({ records = [], hasActiveVehicle }) => records.map(({
  attributes: {
    brandName: [brandName] = [],
    brandLink: [brandLink] = [],
    brandLogoUrl: [brandLogoUrl] = [],
    compatibleCount: [compatibleCount] = []
  } = {}}, index) => {
  const link = processBrandPageLink(brandLink, hasActiveVehicle)
  const compatibilityText = Boolean(compatibleCount) &&
    `${compatibleCount} Tire Line${compatibleCount === '1' ? '' : 's'}`

  return (
    <BrandWrapper key={ index } { ...dynamicDataAttribute('brand', toOneString(brandName)) }>
      <Link tabIndex="-1" to={ link } aria-label={ brandName } aria-hidden="true">
        {
          compatibilityText &&
          <CustomBadge desktop category={ compatibilityText } />
        }
        {
          brandLogoUrl &&
          <Brand data-at-brand-image-wrapper>
            <BrandImage
              src={ `${brandLogoUrl}?$BOT-BrandList-Brand-Desktop-w198$` }
              mobileSrc={ `${brandLogoUrl}?$BOT-BrandList-Brand-Mobile-w106$` } />
          </Brand>
        }
      </Link>
      <H2 noMargin>
        <BrandLink
          data-at-brand-follow-link
          to={ link }
          aria-label={ brandName }
          followLinkTextProps={{ 'aria-hidden': true }}>
          { brandName }
        </BrandLink>
      </H2>
    </BrandWrapper>
  )
})

Records.propTypes = {
  hasActiveVehicle: PropTypes.bool,
  records: PropTypes.arrayOf(PropTypes.shape())
}

export default Records

const BrandWrapper = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: top;
  ${Mixin.responsive('width', '25%', '50%')}
  ${Mixin.responsive('margin', '12px', '8px')}
  ${Mixin.responsive('width', '228px', '136px')}
`

const CustomBadge = styled(Badge)`
  ${Mixin.responsive('top', '20px', '10px')}

  && {
    padding-bottom: 0;
  }

  z-index: 1;
`

const Brand = styled.div`
  z-index: 0;
  background: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('height', '228px', '136px')}
  ${Mixin.responsive('line-height', '228px', '136px')}
`

const BrandImage = styled(Image)`
  padding: 14px;
`

const BrandLink = styled(FollowLink)`
  span {
    display: inline-block;
    ${Media.mobile`
      font-size: 16px;
    `}
  }
`
